import type { User, UserDto } from "@interfaces/user";

export const mapToUserState = (userDto: UserDto): User => {
  const addValue = (value: string | null) => value ?? "";

  return {
    name: addValue(userDto.name),
    email: addValue(userDto.email),
    avatar: addValue(userDto.avatar),
    userName: addValue(userDto.userName),
  };
};
